var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#CCC",
      "stroke-width": "2",
      "d": "M12.66 1A1.34 1.34 0 0 1 14 2.34v7.83c0 .266-.106.522-.297.713l-5.607 5.606-.082-.063a1.5 1.5 0 0 1-.427-.501l-.037-.07L8.717 10H2a1 1 0 0 1-.705-.295A1 1 0 0 1 1 9V7.92l2.727-6.481C3.912 1.165 4.223 1 4.56 1ZM19 1v9h-1V1z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }